import React from 'react';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import * as S from './styles';

type OwnProps = {
  className?: string;
  show?: boolean;
  countryCode: string;
  altText?: string;
  title?: string;
  showTitleAsTooltip?: boolean;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

export const CountryFlag: React.FC<OwnProps> = ({
  className,
  show = true,
  countryCode,
  altText,
  title,
  showTitleAsTooltip = true,
  tooltipPlacement = 'left',
}: OwnProps) => {
  if (!show) {
    return null;
  }

  const size = 16;

  const renderImage = () => {
    return (
      <S.Image
        title={altText}
        alt={altText}
        size={size}
        src={`https://cdn.pji.nu/g/rfe/icons/flags/40x40/${countryCode}.png`}
        srcSet={`https://cdn.pji.nu/g/rfe/icons/flags/40x40/${countryCode}@2x.png 2x`}
      />
    );
  };

  return (
    <>
      {showTitleAsTooltip ? (
        <Tooltip
          placement={tooltipPlacement as TooltipPlacement}
          title={title}
          className={className}
          renderOnMouseOver
        >
          <S.CountryFlag>{renderImage()}</S.CountryFlag>
        </Tooltip>
      ) : (
        <S.CountryFlag className={className}>{renderImage()}</S.CountryFlag>
      )}
    </>
  );
};
